/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "@reduxjs/toolkit";
import { actions as authActions } from '../app/contexts/auth/slice';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
// export function createReducer(injectedReducers = {}) {
//   // Initially we don't have any injectedReducers, so returning identity function to avoid the error
//   if (Object.keys(injectedReducers).length === 0) {
//     return (state) => state;
//   } else {
//     return combineReducers({
//       ...injectedReducers,
//     });
//   }
// }

export function createReducer(injectedReducers = {}) {
  const combinedReducer = combineReducers({
    ...injectedReducers,
  });

  return (state, action) => {
    // Reset all redux state on logout, but preserve auth infrastructure
    if (action.type === authActions.logout.type) {
      const authState = state?.auth;
      state = undefined;
      // After reset, restore Keycloak/auth infrastructure so the app
      // doesn't get stuck on a loading spinner
      const resetState = combinedReducer(state, action);
      if (authState) {
        resetState.auth = {
          ...resetState.auth,
          isKeycloakReady: authState.isKeycloakReady,
          authFlow: authState.authFlow,
          logoutSuccess: true,
          fetchingLoggedInUser: false,
        };
      }
      return resetState;
    }

    return combinedReducer(state, action);
  };
}